import React, { useContext, useState, useEffect } from "react";
import { ModalContext } from "../../utils/Context";
import { postApi } from "../../utils/services";
import { REJECTED_LIST } from "../../utils/apiRoutes";
import RejectedAtModal from "./RejectedAtModal";
import cross from "../../assets/image/cross.png";
import { useTransactionContext } from "../../utils/helpers/useTransaction";

const RejectionModal = ({
  data,
  selectedRowData,
  handlerBillList,
  handlerIndividualBillList,
  handlerPettyCashList,
  handlerPurchaseContractList,
  pageNumber,
  pageSize,
  globalSearch,
  billStatusId,
  billType
}) => {
  const modalContext = useContext(ModalContext);
  const { handleModalData, closeModal } = modalContext;
  const [levelValue, setLevelValue] = useState([]);
  const transactionList = useTransactionContext();
  const user = JSON.parse(localStorage.getItem("userData")) || {};

  const isBulk = selectedRowData && selectedRowData.length > 0;
  const isPettyCash = billType === 1;
  const currentData = isBulk ? selectedRowData[0] : data;

 const handlerLevelApi = async () => {
    try {
      const res = await postApi(REJECTED_LIST, {
        transactionId:
          isPettyCash ? transactionList[5]?.id
            : currentData?.IndividualBill === undefined
              ? transactionList[2]?.id
              : currentData?.IndividualBill
                ? transactionList[4]?.id
                : transactionList[1]?.id,
        roleId: user.RoleId,
      });
      if (res?.res?.rejectedAt_list) {
        setLevelValue(res.res.rejectedAt_list);
      }
    } catch (error) {
      console.error("Error fetching rejection levels:", error);
    }
  };

  useEffect(() => {
    if (user?.RoleId) {
      handlerLevelApi();
    }
  }, [user?.RoleId]);

  if (isPettyCash && isBulk) {
    return (
      <div className="custom-cnfm-mdl">
        <div className="modal-body ">
          <span className="cross" onClick={closeModal}>
            <img src={cross} alt="close" />
          </span>
          <h2>Operation Not Allowed</h2>
          <h6>Bulk rejection is not available for Petty Cash.</h6>
        </div>
      </div>
    );
  }

  const handleReject = (rejectionType) => {
    let handlerListToUse;

    if (isPettyCash) {
      handlerListToUse = handlerPettyCashList;
    } else {
      handlerListToUse =
        currentData?.IndividualBill === undefined
          ? handlerPurchaseContractList
          : currentData?.IndividualBill
            ? handlerIndividualBillList
            : handlerBillList;
    }

    const rejectedAt = (
      <RejectedAtModal
        data={isBulk ? selectedRowData : data}
        levelValue={levelValue}
        handlerList={handlerListToUse}
        rejectionType={rejectionType}
        pageNumber={pageNumber}
        pageSize={pageSize}
        globalSearch={globalSearch}
        billStatusId={billStatusId}
        billType={billType}
      />
    );

    handleModalData(rejectedAt, "md");
  };

  const getBillLabel = () => {
    if (isPettyCash) return "Petty Cash";
    if (currentData?.IndividualBill === undefined) return "Purchase Contract";
    if (currentData?.IndividualBill) return "Standalone Bill";
    return "Bill";
  };

  return (
    <div className="custom-cnfm-mdl">
      <div className="modal-body ">
        <span className="cross" onClick={closeModal}>
          <img src={cross} alt="close" />
        </span>
        <h2>Are you sure?</h2>
        <h6>
          Are you sure you want to reject {isBulk ? "these" : "this"}{" "}
          {getBillLabel()}? This action cannot be reverted.
        </h6>
        <div className="modal-footer d-flex align-items-center justify-content-center mb-20 gap-2">
          <div className="danger-btn">
            <button
              type="button"
              className="btn"
              onClick={() => handleReject("Requester")}
            >
              Reject to Requester
            </button>
          </div>
          <div className="cstm-lvl-btn">
            <button
              disabled={levelValue.length === 0}
              type="submit"
              className="btn"
              onClick={() => handleReject("RejectAt")}
            >
              Reject at
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;